import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const HOME = { admin: "/", izleyici: "/ozet", user: "/cari", katip: "/haciz-gundemi", avukat: "/kayitlar" };

export default function ProtectedRoute({ children, adminOnly, allow }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="kicker animate-pulse">Yükleniyor...</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  const role = user.role || "user";
  if (role === "izleyici" && loc.pathname !== "/ozet") return <Navigate to="/ozet" replace />;
  if (adminOnly && role !== "admin") return <Navigate to={HOME[role] || "/cari-panel"} replace />;
  if (allow && !allow.includes(role)) return <Navigate to={HOME[role] || "/cari-panel"} replace />;
  return children;
}
